// extracted by mini-css-extract-plugin
export default {"root":"BillingPage_root__5cblB","paper":"BillingPage_paper__qL9X3"};